/**
 * Deterministic stringify for action payloads so debounce keys and request fingerprints
 * match semantically equivalent objects (sorted keys, Date → ms).
 */
export function stableSerializeActionPayload(payload: unknown): string {
  if (payload === null || payload === undefined) {
    return String(payload);
  }
  if (typeof payload !== 'object') {
    return JSON.stringify(payload);
  }
  if (payload instanceof Date) {
    return JSON.stringify(payload.getTime());
  }
  if (Array.isArray(payload)) {
    return `[${payload.map(stableSerializeActionPayload).join(',')}]`;
  }
  const obj = payload as Record<string, unknown>;
  const keys = Object.keys(obj).sort();
  const parts: string[] = [];
  for (const k of keys) {
    parts.push(`${JSON.stringify(k)}:${stableSerializeActionPayload(obj[k])}`);
  }
  return `{${parts.join(',')}}`;
}
